import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
export var StyledGridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-rows: auto 1fr;\n  height: 100%;\n"], ["\n  display: grid;\n  grid-template-rows: auto 1fr;\n  height: 100%;\n"])));
export default StyledGridContainer;
var templateObject_1;
//# sourceMappingURL=styles.js.map